import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { BasicActions } from '../actions/BasicActions';
import { BasicVariable } from '../../domain/enrichment/EnrichmentDomain';
import { BasicVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export interface BasicState {
  basicVariable: BasicVariable;
  schema: DeploymentModel<BasicVariableSchema> | null;
  isUpdate: boolean;
  dependencies: ComponentDependency[];
  isDirty: boolean;
}

const initialState: BasicState = {
  basicVariable: ValueFactory.initializeBasicVariable(),
  schema: { stage: 'DRAFT' } as DeploymentModel<BasicVariableSchema>,
  isUpdate: false,
  dependencies: [],
  isDirty: false,
};

export const basicReducer = (state = initialState, action: ReduxBaseAction<any, BasicActions>) => {
  switch (action.type) {
    case 'CHANGE_BASIC':
      return { ...state, basicVariable: action.payload || ValueFactory.initializeBasicVariable(), isDirty: true };
    case 'CHANGE_BASIC_SCHEMA':
      return { ...state, schema: action.payload };
    case 'CHANGE_BASIC_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_BASIC':
      return { ...state, basicVariable: ValueFactory.initializeBasicVariable(), schema: null, isDirty: false };
    case 'CHANGE_BASIC_DEPENDENCIES':
      return { ...state, dependencies: action.payload };
    case 'CHANGE_BASIC_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
